import React from 'react'
import { CreateSupportAnnounce8Container } from '../../containers/Officer/CreateSupportAnnounce8Container'
export const CreateSupportAnnounce8Page = () => {
    return (
        <CreateSupportAnnounce8Container />
    )
}
